import type { ReactNode } from "react";
import MuiButton from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import type { ButtonProps as MuiButtonProps } from "@mui/material/Button";

type ButtonProps = {
  asChild?: boolean;
  children: ReactNode;
} & MuiButtonProps;

export function Button({ asChild, children, loading, ...props }: ButtonProps & { loading?: boolean }) {
  if (asChild && typeof children === "object") {
    return children;
  }
  return (
    <MuiButton {...props} disabled={props.disabled || loading}>
      {loading ? <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} /> : null}
      {children}
    </MuiButton>
  );
}